import { InjectionToken } from '@angular/core';

/**
 * When **true**, {@link CadsMainTemplateComponent} suppresses the built-in back control (provided by
 * {@link CadsMainTemplateModalComponent} for projected templates).
 */
export const CADS_MAIN_TEMPLATE_MODAL_CONTEXT = new InjectionToken<boolean>(
  'CADS_MAIN_TEMPLATE_MODAL_CONTEXT',
);
